import { createFileRoute, redirect } from '@tanstack/react-router';

/* The page's old address, kept so bookmarks and shared links still land. */
export const Route = createFileRoute('/_app/admin/staff-mcp')({
  staticData: { orgScope: 'none' },
  beforeLoad: () => {
    throw redirect({ to: '/admin/mcp', replace: true });
  },
});
